"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var front_end_validation_1 = __importDefault(require("@nordicscreen/front-end-validation"));
var NewFolderModal = function (props) {
    var logger = q_play_core_1.logManager.getLogger();
    var _a = (0, react_1.useState)(""), folderNameError = _a[0], setFolderNameError = _a[1];
    var _b = (0, react_1.useState)(""), folderName = _b[0], setFolderName = _b[1];
    var _c = (0, react_1.useState)(true), buttonDisabled = _c[0], setButtonDisabled = _c[1];
    var _d = (0, react_1.useState)(false), isLoading = _d[0], setIsLoading = _d[1];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    (0, react_1.useEffect)(function () {
        if (!props.isShown) {
            setFolderName("");
            setFolderNameError("");
            setButtonDisabled(true);
            setIsLoading(false);
        }
    }, [props.isShown]);
    var inputValidation = function (event) {
        event.preventDefault();
        var value = event.target.value;
        setFolderName(value);
        try {
            new front_end_validation_1.default(value)
                .validate("should.have.maxLength", t("The folder name is too long, it cannot be longer than 255 characters"), "255")
                .check();
            setFolderNameError("");
            setButtonDisabled(value.trim() === "");
        }
        catch (e) {
            logger.error(e[0].message);
            setFolderNameError(e[0].message);
            setButtonDisabled(true);
            setIsLoading(false);
        }
    };
    var createFolder = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setButtonDisabled(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, props.createFolder(folderName)];
                case 2:
                    _a.sent();
                    props.toggle();
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Error creating folder:", error_1);
                    setButtonDisabled(false);
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: props.toggle, dialogClassName: MediaLibrary_module_css_1.default["modal-dialog"], centered: true, body: react_1.default.createElement("form", { id: "create-new-folder-form", "data-cy": "newFolderModal" },
            react_1.default.createElement("div", { className: "".concat(MediaLibrary_module_css_1.default["new-folder-modal-header"], " row"), style: { marginBottom: "10px" } },
                react_1.default.createElement("div", { className: "col-sm" }, t("Create folder"))),
            react_1.default.createElement("div", { className: "col-sm" },
                react_1.default.createElement("label", { htmlFor: "folder-name", className: "d-block ns-font-size-15", style: { color: "var(--info-color)" } }, t("Folder name")),
                react_1.default.createElement(q_play_components_1.Input, { id: "folder-name", style: { height: "47px", borderRadius: "4px", marginTop: "10px" }, onChange: function (e) {
                        setFolderName(e.target.value);
                        inputValidation(e);
                    }, value: folderName, autoFocus: true, dataCy: "folderNameInput" }),
                react_1.default.createElement("p", { style: {
                        color: "var(--warning-color)",
                        fontFamily: "var(--bs-body-font-family)",
                    } }, folderNameError)),
            react_1.default.createElement("div", { className: "d-flex justify-content-center", style: { marginTop: "25.5px" } },
                react_1.default.createElement(q_play_components_1.Button, { onClick: createFolder, isDisabled: buttonDisabled, id: "store-button", text: t("Create folder"), variant: "primary", size: "small", style: { width: "122px" }, dataCy: "createFolderButton", isLoading: isLoading }))) }));
};
exports.default = NewFolderModal;
